import PropTypes from 'prop-types';
import moment from 'moment';

export const SHORT_TIME = 'SHORT_TIME';
export const SHORT_DATE = 'SHORT_DATE';
export const LONG_DATE = 'LONG_DATE';
export const DATETIME = 'DATETIME';
export const LONG_DATETIME = 'LONG_DATETIME';
export const LONGEST_DATETIME = 'LONGEST_DATETIME';

DateTime.propTypes = {
    value: PropTypes.string,
    format: PropTypes.string,
};

export const convertFormatToPattern = (format) => {
    let result;
    switch (format) {
        case SHORT_TIME:
            result = 'HH:mm';
            break;
        case SHORT_DATE:
            result = 'DD.MM.';
            break;
        case LONG_DATE:
            result = 'DD.MM.YYYY';
            break;
        case DATETIME:
            result = 'DD.MM.YYYY HH:mm';
            break;
        case LONG_DATETIME:
            result = 'DD.MM.YYYY HH:mm:ss';
            break;
        case LONGEST_DATETIME:
            result = 'DD.MM.YYYY HH:mm:ss.SSS';
            break;
        default:
            throw new Error(`'Unknown DateTime format: ${format}`);
    }
    return result;
};

function DateTime(props) {
    const {
        value = null,
        format = DATETIME,
    } = props;
    return value ? moment(new Date(value)).format(convertFormatToPattern(format)) : '';
}

export default DateTime;
